import BaseTextField from "components/base/TextField"
import useInput from "hooks/use_input"
import BaseMask from "../../base/Mask"
import useTranslation from "hooks/use_translation"

const BirthDate = () => {
  const id = "birthday"
  const { fields } = useTranslation()

  const validate = (value) => {
    if (value === "") return fields?.required

    return ""
  }

  const { handleChange, inputValue, errorMessage, handleBlur } = useInput(id, validate)

  return (
    <BaseTextField
      id={id}
      _label={fields?.date_of_birth_title}
      value={inputValue}
      onChange={handleChange}
      error={errorMessage?.length > 0}
      onBlur={handleBlur}
      helperText={errorMessage}
      InputProps={{
        inputComponent: BaseMask,
        inputProps: {
          mask: "0000-00-00",
          placeholder: "YYYY-DD-MM",
        },
      }}
    />
  )
}

export default BirthDate
